// extracted by mini-css-extract-plugin
module.exports = {"ServiceResourceslabel":"ServiceResourceslabel_tKkBs"};